
(function(){
  'use strict';
  var VERSION='4.9.9';

  function boot(root){
    if(!root || root.dataset.amiHomeParityBound===VERSION)return;
    root.dataset.amiHomeParityBound=VERSION;
    var launch=root.querySelector('[data-ami-home-workspace-launch]');
    var close=root.querySelector('[data-ami-close]');
    if(!launch)return;

    function sync(){
      var open=root.classList.contains('is-open');
      launch.setAttribute('aria-expanded',open?'true':'false');
      /* v4.9.9: opening Ami must not reposition the underlying page.
         The full-screen frosted conversation owns focus instead. */
    }

    var observer=new MutationObserver(function(mutations){
      for(var i=0;i<mutations.length;i+=1){
        if(mutations[i].attributeName==='class'){sync();break;}
      }
    });
    observer.observe(root,{attributes:true,attributeFilter:['class']});

    if(close){
      close.addEventListener('click',function(){
        window.setTimeout(function(){
          launch.setAttribute('aria-expanded','false');
          try{launch.focus({preventScroll:true});}catch(e){launch.focus();}
        },0);
      });
    }
    sync();
  }

  function bootAll(scope){
    var ctx=scope&&scope.querySelectorAll?scope:document;
    Array.prototype.forEach.call(ctx.querySelectorAll('[data-ami-home-workspace-parity]'),boot);
  }

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){bootAll(document);},{once:true});
  else bootAll(document);
  document.addEventListener('shopify:section:load',function(e){bootAll(e.target||document);});
})();
